import { TODO, UIBModal } from '@b2b/types/core';
import angular, { IScope } from 'angular';

PriceListsRemoveModalController.$inject = ['$scope', '$uibModalInstance', 'currentPriceList'];

function PriceListsRemoveModalController(
  $scope: IScope & {
    cancel: TODO;
    done: TODO;
    errors: TODO;
    hasErrors: TODO;
    init: TODO;
    model: TODO;
    success: TODO;
  },
  $uibModalInstance: UIBModal<TODO>,
  currentPriceList: TODO
) {
  $scope.errors = [];

  $scope.model = {
    name: currentPriceList.name,
  };

  $scope.init = function () {};

  $scope.hasErrors = function () {
    return $scope.errors.length > 0;
  };

  $scope.done = function () {
    $scope.success();
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.success = function () {
    $uibModalInstance.close(true);
  };

  $scope.init();
}

export const PriceListsRemoveModalControllerModule = angular
  .module('acme.view.application.pricing.lists.removeModal.controllers', [])
  .controller('PriceListsRemoveModalController', PriceListsRemoveModalController).name;
